module.exports = __webpack_public_path__ + "img/terroir-charcoal-2-mobile.c760f572.jpg";